import { blazyInit } from '../sitewide.js';
import { hashScrollInit } from '../sitewide.js';
import { searchInit } from '../sitewide.js';

class WorkCategory {
	namespace = 'work-category';
	beforeEnter = data => {
		//console.log(data);
	};
	afterEnter() {
		//blazyInit();
		//hashScrollInit();
		searchInit();
	};
}

export default new WorkCategory();
